import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ServerForm from './ServerForm';
import Loading from './Loading';
import { serverAPI, ServerRecord } from '../utils/api';

const EditServer: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [server, setServer] = useState<ServerRecord | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadServer = async () => {
      if (!id) {
        setError('Server ID is missing');
        setIsLoading(false);
        return;
      }

      try {
        const serverData = await serverAPI.getServerById(id);
        setServer(serverData);
      } catch (err) {
        console.error('Failed to load server:', err);
        const message = (err as Error & { details?: { message?: string } })?.details?.message;
        setError(message || 'Failed to load server');
      } finally {
        setIsLoading(false);
      }
    };

    loadServer();
  }, [id]);

  const handleSuccess = () => {
    navigate(`/server/${id}`);
  };

  const handleCancel = () => {
    navigate(`/server/${id}`);
  };

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Loading message="Loading server..." />
      </div>
    );
  }

  if (error || !server) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-red-100 dark:bg-red-900/60 border border-red-300 dark:border-red-700 text-red-700 dark:text-red-100 rounded-xl p-6">
          {error || 'Server not found'}
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <ServerForm server={server} onSuccess={handleSuccess} onCancel={handleCancel} />
    </div>
  );
};

export default EditServer;
